<navbar></navbar>
<div class="container bg-white">
    <div class="row">
        <div class="col">
            <h1>Recon</h1>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <img width="100%" src="assets/map.png" alt="Site Map">
        </div>
    </div>
</div>
